var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F0EEEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2128_18255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2128_18255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 61C59.9411 61 68 52.9411 68 43C68 33.0589 59.9411 25 50 25C40.0589 25 32 33.0589 32 43C32 52.9411 40.0589 61 50 61Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 97.0002V99.5002H87.5V97.0002C87.5 87.666 87.5 82.9989 85.6835 79.4337C84.0856 76.2977 81.5358 73.7479 78.3998 72.15C74.8346 70.3335 70.1675 70.3335 60.8333 70.3335H39.1667C29.8325 70.3335 25.1654 70.3335 21.6002 72.15C18.4641 73.7479 15.9144 76.2977 14.3166 79.4337C12.5 82.9989 12.5 87.666 12.5 97.0002Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar-default.2ae9d62a3dab351415a4002aff1c9f81.svg";
export { ForwardRef as ReactComponent };